const files = require.context('.', true, /\.js$/)
const answer = {}

files.keys().forEach((key) => {
  if (key === './index.js' || key === './config.js' || key === './logic.js' || key === './answer.js' || key === './validate.js' ||
  key === './answerValidate.js') {
    return
  }
  if (key.indexOf('answer.js') > -1) {
    answer[key.substring(key.indexOf('/') + 1, key.lastIndexOf('/'))] = files(key).default
  }
})
export default answer



// WEBPACK FOOTER //
// ./src/components/editor/answer.js